/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { ScanPhoto } from "../../../../gen/scan_planner/scan_photo";
import { ScanWaypoint } from "../../../../gen/scan_planner/scan_waypoint";
import { Uuid } from "../../../../gen/uuid_util/uuid";
import { FrameType_Enum, frameType_EnumFromJSON, frameType_EnumToJSON } from "../../waypoints";
import { TakePhotoActionArgs } from "../take_photo/take_photo";
import {
  InspectFailureReason,
  inspectFailureReasonFromJSON,
  inspectFailureReasonToJSON,
} from "../trajectory_inspect/trajectory_inspect";

export const protobufPackage = "skills";

/** Args of the atomic action to perform at a photo waypoint. */
export interface PhotoWaypointAction {
  /**
   * NOTE(Ayush): WB, ISO, EXPOSURE, and Comp will not be respected. Instead, the active vehicle
   * settings will be used.
   */
  takePhoto?: TakePhotoActionArgs | undefined;
}

export interface MotionSettings {
  /**
   * The max translational velocity that the vehicle is allowed to have at any point during the
   * execution of the plan
   */
  globalVelocityLimit: number;
}

export interface StopForPhotoInspectActionArgs {
  /** Waypoints from the scan plan */
  scanWaypoints: ScanWaypoint[];
  /** The frame in which scan_waypoints are specified */
  frame: FrameType_Enum;
  /** Actions to perform at each photo waypoint. */
  photoWaypointAction: PhotoWaypointAction | undefined;
  motionSettings: MotionSettings | undefined;
}

export interface StopForPhotoInspectResultData {
  completedWaypointUuids: Uuid[];
  photos: ScanPhoto[];
  failureReason: InspectFailureReason;
  /** Inspection time in seconds (excluding paused time) */
  inspectionTimeS: number;
}

export interface StopForPhotoInspectActionStateData {
  /** index of the last completed waypoint (any type) */
  lastCompletedWaypointIdx: number;
  /** estimated time to completion of the trajectory in seconds */
  estimatedTimeToCompletionS: number;
  /** Number of photo waypoints captured so far */
  numPhotoWaypointsCaptured: number;
  /** Number of photo waypoints which have failed or have been skipped */
  numPhotoWaypointsFailedOrSkipped: number;
  /** Number of consecutive photo waypoints where we have been stuck. */
  numConsecutiveStuckPhotoWaypoints: number;
}

function createBasePhotoWaypointAction(): PhotoWaypointAction {
  return { takePhoto: undefined };
}

export const PhotoWaypointAction = {
  encode(message: PhotoWaypointAction, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.takePhoto !== undefined) {
      TakePhotoActionArgs.encode(message.takePhoto, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PhotoWaypointAction {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePhotoWaypointAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.takePhoto = TakePhotoActionArgs.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PhotoWaypointAction {
    return { takePhoto: isSet(object.takePhoto) ? TakePhotoActionArgs.fromJSON(object.takePhoto) : undefined };
  },

  toJSON(message: PhotoWaypointAction): unknown {
    const obj: any = {};
    if (message.takePhoto !== undefined) {
      obj.takePhoto = TakePhotoActionArgs.toJSON(message.takePhoto);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PhotoWaypointAction>, I>>(base?: I): PhotoWaypointAction {
    return PhotoWaypointAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PhotoWaypointAction>, I>>(object: I): PhotoWaypointAction {
    const message = createBasePhotoWaypointAction();
    message.takePhoto = (object.takePhoto !== undefined && object.takePhoto !== null)
      ? TakePhotoActionArgs.fromPartial(object.takePhoto)
      : undefined;
    return message;
  },
};

function createBaseMotionSettings(): MotionSettings {
  return { globalVelocityLimit: 0 };
}

export const MotionSettings = {
  encode(message: MotionSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.globalVelocityLimit !== 0) {
      writer.uint32(13).float(message.globalVelocityLimit);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MotionSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMotionSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.globalVelocityLimit = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MotionSettings {
    return {
      globalVelocityLimit: isSet(object.globalVelocityLimit) ? globalThis.Number(object.globalVelocityLimit) : 0,
    };
  },

  toJSON(message: MotionSettings): unknown {
    const obj: any = {};
    if (message.globalVelocityLimit !== 0) {
      obj.globalVelocityLimit = message.globalVelocityLimit;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MotionSettings>, I>>(base?: I): MotionSettings {
    return MotionSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MotionSettings>, I>>(object: I): MotionSettings {
    const message = createBaseMotionSettings();
    message.globalVelocityLimit = object.globalVelocityLimit ?? 0;
    return message;
  },
};

function createBaseStopForPhotoInspectActionArgs(): StopForPhotoInspectActionArgs {
  return { scanWaypoints: [], frame: 0, photoWaypointAction: undefined, motionSettings: undefined };
}

export const StopForPhotoInspectActionArgs = {
  encode(message: StopForPhotoInspectActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.scanWaypoints) {
      ScanWaypoint.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.frame !== 0) {
      writer.uint32(16).int32(message.frame);
    }
    if (message.photoWaypointAction !== undefined) {
      PhotoWaypointAction.encode(message.photoWaypointAction, writer.uint32(26).fork()).ldelim();
    }
    if (message.motionSettings !== undefined) {
      MotionSettings.encode(message.motionSettings, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StopForPhotoInspectActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopForPhotoInspectActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.scanWaypoints.push(ScanWaypoint.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.frame = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.photoWaypointAction = PhotoWaypointAction.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.motionSettings = MotionSettings.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopForPhotoInspectActionArgs {
    return {
      scanWaypoints: globalThis.Array.isArray(object?.scanWaypoints)
        ? object.scanWaypoints.map((e: any) => ScanWaypoint.fromJSON(e))
        : [],
      frame: isSet(object.frame) ? frameType_EnumFromJSON(object.frame) : 0,
      photoWaypointAction: isSet(object.photoWaypointAction)
        ? PhotoWaypointAction.fromJSON(object.photoWaypointAction)
        : undefined,
      motionSettings: isSet(object.motionSettings) ? MotionSettings.fromJSON(object.motionSettings) : undefined,
    };
  },

  toJSON(message: StopForPhotoInspectActionArgs): unknown {
    const obj: any = {};
    if (message.scanWaypoints?.length) {
      obj.scanWaypoints = message.scanWaypoints.map((e) => ScanWaypoint.toJSON(e));
    }
    if (message.frame !== 0) {
      obj.frame = frameType_EnumToJSON(message.frame);
    }
    if (message.photoWaypointAction !== undefined) {
      obj.photoWaypointAction = PhotoWaypointAction.toJSON(message.photoWaypointAction);
    }
    if (message.motionSettings !== undefined) {
      obj.motionSettings = MotionSettings.toJSON(message.motionSettings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StopForPhotoInspectActionArgs>, I>>(base?: I): StopForPhotoInspectActionArgs {
    return StopForPhotoInspectActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopForPhotoInspectActionArgs>, I>>(
    object: I,
  ): StopForPhotoInspectActionArgs {
    const message = createBaseStopForPhotoInspectActionArgs();
    message.scanWaypoints = object.scanWaypoints?.map((e) => ScanWaypoint.fromPartial(e)) || [];
    message.frame = object.frame ?? 0;
    message.photoWaypointAction = (object.photoWaypointAction !== undefined && object.photoWaypointAction !== null)
      ? PhotoWaypointAction.fromPartial(object.photoWaypointAction)
      : undefined;
    message.motionSettings = (object.motionSettings !== undefined && object.motionSettings !== null)
      ? MotionSettings.fromPartial(object.motionSettings)
      : undefined;
    return message;
  },
};

function createBaseStopForPhotoInspectResultData(): StopForPhotoInspectResultData {
  return { completedWaypointUuids: [], photos: [], failureReason: 0, inspectionTimeS: 0 };
}

export const StopForPhotoInspectResultData = {
  encode(message: StopForPhotoInspectResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.completedWaypointUuids) {
      Uuid.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.photos) {
      ScanPhoto.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.failureReason !== 0) {
      writer.uint32(24).int32(message.failureReason);
    }
    if (message.inspectionTimeS !== 0) {
      writer.uint32(48).int64(message.inspectionTimeS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StopForPhotoInspectResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopForPhotoInspectResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.completedWaypointUuids.push(Uuid.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.photos.push(ScanPhoto.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.failureReason = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.inspectionTimeS = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopForPhotoInspectResultData {
    return {
      completedWaypointUuids: globalThis.Array.isArray(object?.completedWaypointUuids)
        ? object.completedWaypointUuids.map((e: any) => Uuid.fromJSON(e))
        : [],
      photos: globalThis.Array.isArray(object?.photos) ? object.photos.map((e: any) => ScanPhoto.fromJSON(e)) : [],
      failureReason: isSet(object.failureReason) ? inspectFailureReasonFromJSON(object.failureReason) : 0,
      inspectionTimeS: isSet(object.inspectionTimeS) ? globalThis.Number(object.inspectionTimeS) : 0,
    };
  },

  toJSON(message: StopForPhotoInspectResultData): unknown {
    const obj: any = {};
    if (message.completedWaypointUuids?.length) {
      obj.completedWaypointUuids = message.completedWaypointUuids.map((e) => Uuid.toJSON(e));
    }
    if (message.photos?.length) {
      obj.photos = message.photos.map((e) => ScanPhoto.toJSON(e));
    }
    if (message.failureReason !== 0) {
      obj.failureReason = inspectFailureReasonToJSON(message.failureReason);
    }
    if (message.inspectionTimeS !== 0) {
      obj.inspectionTimeS = Math.round(message.inspectionTimeS);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StopForPhotoInspectResultData>, I>>(base?: I): StopForPhotoInspectResultData {
    return StopForPhotoInspectResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopForPhotoInspectResultData>, I>>(
    object: I,
  ): StopForPhotoInspectResultData {
    const message = createBaseStopForPhotoInspectResultData();
    message.completedWaypointUuids = object.completedWaypointUuids?.map((e) => Uuid.fromPartial(e)) || [];
    message.photos = object.photos?.map((e) => ScanPhoto.fromPartial(e)) || [];
    message.failureReason = object.failureReason ?? 0;
    message.inspectionTimeS = object.inspectionTimeS ?? 0;
    return message;
  },
};

function createBaseStopForPhotoInspectActionStateData(): StopForPhotoInspectActionStateData {
  return {
    lastCompletedWaypointIdx: 0,
    estimatedTimeToCompletionS: 0,
    numPhotoWaypointsCaptured: 0,
    numPhotoWaypointsFailedOrSkipped: 0,
    numConsecutiveStuckPhotoWaypoints: 0,
  };
}

export const StopForPhotoInspectActionStateData = {
  encode(message: StopForPhotoInspectActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.lastCompletedWaypointIdx !== 0) {
      writer.uint32(8).int32(message.lastCompletedWaypointIdx);
    }
    if (message.estimatedTimeToCompletionS !== 0) {
      writer.uint32(21).float(message.estimatedTimeToCompletionS);
    }
    if (message.numPhotoWaypointsCaptured !== 0) {
      writer.uint32(24).uint32(message.numPhotoWaypointsCaptured);
    }
    if (message.numPhotoWaypointsFailedOrSkipped !== 0) {
      writer.uint32(32).uint32(message.numPhotoWaypointsFailedOrSkipped);
    }
    if (message.numConsecutiveStuckPhotoWaypoints !== 0) {
      writer.uint32(40).uint32(message.numConsecutiveStuckPhotoWaypoints);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StopForPhotoInspectActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopForPhotoInspectActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.lastCompletedWaypointIdx = reader.int32();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.estimatedTimeToCompletionS = reader.float();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.numPhotoWaypointsCaptured = reader.uint32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.numPhotoWaypointsFailedOrSkipped = reader.uint32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.numConsecutiveStuckPhotoWaypoints = reader.uint32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopForPhotoInspectActionStateData {
    return {
      lastCompletedWaypointIdx: isSet(object.lastCompletedWaypointIdx)
        ? globalThis.Number(object.lastCompletedWaypointIdx)
        : 0,
      estimatedTimeToCompletionS: isSet(object.estimatedTimeToCompletionS)
        ? globalThis.Number(object.estimatedTimeToCompletionS)
        : 0,
      numPhotoWaypointsCaptured: isSet(object.numPhotoWaypointsCaptured)
        ? globalThis.Number(object.numPhotoWaypointsCaptured)
        : 0,
      numPhotoWaypointsFailedOrSkipped: isSet(object.numPhotoWaypointsFailedOrSkipped)
        ? globalThis.Number(object.numPhotoWaypointsFailedOrSkipped)
        : 0,
      numConsecutiveStuckPhotoWaypoints: isSet(object.numConsecutiveStuckPhotoWaypoints)
        ? globalThis.Number(object.numConsecutiveStuckPhotoWaypoints)
        : 0,
    };
  },

  toJSON(message: StopForPhotoInspectActionStateData): unknown {
    const obj: any = {};
    if (message.lastCompletedWaypointIdx !== 0) {
      obj.lastCompletedWaypointIdx = Math.round(message.lastCompletedWaypointIdx);
    }
    if (message.estimatedTimeToCompletionS !== 0) {
      obj.estimatedTimeToCompletionS = message.estimatedTimeToCompletionS;
    }
    if (message.numPhotoWaypointsCaptured !== 0) {
      obj.numPhotoWaypointsCaptured = Math.round(message.numPhotoWaypointsCaptured);
    }
    if (message.numPhotoWaypointsFailedOrSkipped !== 0) {
      obj.numPhotoWaypointsFailedOrSkipped = Math.round(message.numPhotoWaypointsFailedOrSkipped);
    }
    if (message.numConsecutiveStuckPhotoWaypoints !== 0) {
      obj.numConsecutiveStuckPhotoWaypoints = Math.round(message.numConsecutiveStuckPhotoWaypoints);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StopForPhotoInspectActionStateData>, I>>(
    base?: I,
  ): StopForPhotoInspectActionStateData {
    return StopForPhotoInspectActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopForPhotoInspectActionStateData>, I>>(
    object: I,
  ): StopForPhotoInspectActionStateData {
    const message = createBaseStopForPhotoInspectActionStateData();
    message.lastCompletedWaypointIdx = object.lastCompletedWaypointIdx ?? 0;
    message.estimatedTimeToCompletionS = object.estimatedTimeToCompletionS ?? 0;
    message.numPhotoWaypointsCaptured = object.numPhotoWaypointsCaptured ?? 0;
    message.numPhotoWaypointsFailedOrSkipped = object.numPhotoWaypointsFailedOrSkipped ?? 0;
    message.numConsecutiveStuckPhotoWaypoints = object.numConsecutiveStuckPhotoWaypoints ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
